import React from "react";
import styled from "styled-components";
import { Button, Panel } from "components/bootstrap";
import { Icon } from "components/common";
import AggregationConditionSummary from "./AggregationConditionSummary";
const StyledPanel = styled(Panel)`
  margin-top: 10px;
`;
const StyledButton = styled(Button)`
  margin-left: 15px;
  vertical-align: baseline;
`;
const AggregationConditionsFormSummary = ({
  conditions,
  series,
  expressionValidation = { isValid: true },
  showInlineValidation = false,
  toggleShowValidation
}) => /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(StyledPanel, { header: "Condition summary" }, expressionValidation.isValid ? /* @__PURE__ */ React.createElement("p", { className: "text-success" }, /* @__PURE__ */ React.createElement(Icon, { name: "check_box" }), "\xA0Condition is valid") : /* @__PURE__ */ React.createElement("p", { className: "text-danger" }, /* @__PURE__ */ React.createElement(Icon, { name: "warning" }), "\xA0Condition is not valid", /* @__PURE__ */ React.createElement(StyledButton, { bsSize: "xsmall", onClick: toggleShowValidation }, showInlineValidation ? "Hide errors" : "Show errors")), /* @__PURE__ */ React.createElement("b", null, "Preview:"), " ", /* @__PURE__ */ React.createElement(AggregationConditionSummary, { series, conditions })));
export default AggregationConditionsFormSummary;
